module.exports = __webpack_public_path__ + "img/canva-logo.d89201aa.png";